const category = [
  {
    id: 1,
    title: "All",
    imageUrl:
      "https://i.etsystatic.com/32975082/r/il/0b16db/3984143162/il_794xN.3984143162_jzlv.jpg",
  },
  {
    id: 2,
    title: "Aqua Bijoux",
    imageUrl:
      "https://i.etsystatic.com/32975082/r/il/3bfcf9/4031808127/il_794xN.4031808127_6puv.jpg",
  },
  {
    id: 3,
    title: "Waist beads",
    imageUrl:
      "https://i.etsystatic.com/32975082/r/il/e55594/4002682960/il_794xN.4002682960_l15e.jpg",
  },
  {
    id: 4,
    title: "Custom T-shirts",
    imageUrl:
      "https://i.etsystatic.com/32975082/r/il/058577/3620912809/il_794xN.3620912809_c7mr.jpg",
  },
  {
    id: 5,
    title: "Black Excellence",
    imageUrl:
      "https://i.etsystatic.com/32975082/r/il/641ff4/3722983056/il_794xN.3722983056_89cu.jpg",
  },
];
export default category
